export const clientCopy = {
  registradoEmSombra: "Registrado. Em sombra, nada foi escrito.",
  jaDecidida: "Alguém decidiu antes.",
  segurando: { aprovar: "Aprovando…", recusar: "Recusando…", ajustar: "Aprovando o novo valor…" },
  desfeita: "Desfeito: nada foi enviado.",
  naoCarregou: "Não carregou. Recarregue a página.",
  novidades: (count: number) => `${count} ${count === 1 ? "novidade" : "novidades"} · mostrar`,
} as const;
